import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { DadosPessoa } from "../models/account/dados-pessoa.model";
import { Injectable } from '@angular/core';
import { AlterarSenhaPessoa } from "../models/account/alterar-senha-pessoa.model";
import { PerguntaAleatoria } from "../models/account/pergunta-aleatoria.model";

@Injectable()
export class AccountService {
    constructor(private httpClient: HttpClient) { }

    ConfirmarDadosPessoa(dadosPessoa: DadosPessoa): Observable<PerguntaAleatoria> {
        return this.httpClient.post<PerguntaAleatoria>(`/account/ConfirmaPessoa/GerarPerguntar/`, dadosPessoa);
    };

    ValidarRespostaPerguntaAleatoria(respostaCorreta: { cpf: string; id: number; resposta: string; }): Observable<string> {
        return this.httpClient.post<string>(`/account/ConfirmaPessoa/ValidarResposta/`, respostaCorreta);
    }

    AlterarSenhaPessoa(dadosPessoa: AlterarSenhaPessoa): Observable<string> {
        return this.httpClient.post<string>(`/account/AlterarSenha/`, dadosPessoa);
    };
}



// WEBPACK FOOTER //
// ./src/app/services/account.service.ts